export default __webpack_public_path__ + "static/media/JPG輪播1-3.a696f7ee.jpg";